import { FunctionComponent } from 'react'
import styles from './SpinningSettingsIcon.module.scss'
import { Settings } from '@mui/icons-material'
import { CSSProperties } from '@mui/material'
import { useCurrentDaycareInfos } from '@/hooks/useCurrentDaycareInfos'
import { Link } from 'react-router-dom'

interface SpinningSettingsIconProps {
    section?: string
    size?: number
}

const SpinningSettingsIcon: FunctionComponent<SpinningSettingsIconProps> = ({
    section,
    size
}: SpinningSettingsIconProps) => {
    const { currentDaycare } = useCurrentDaycareInfos()
    const linkSuffix: string | undefined = section && `#${section}`
    return (
        <Link to={`/daycare?daycare=${currentDaycare.id}` + linkSuffix}>
            <Settings className={styles.Icon} style={{ '--icon-size': size ? `${size}px` : '100%' } as CSSProperties} />
        </Link>
    )
}

export default SpinningSettingsIcon
